import _ from 'lodash';
import moment from 'moment';
import DepsService from 'services/dependencies';
import restApi from 'app/rest.conf.json';
import {
  applySessionData as applySessionDataRedux,
  changeLocale as changeLocaleRedux,
  initializeSession as initializeSessionRedux,
  resetSession as resetSessionRedux,
  setAttemptedRoute,
  updateAuthHeaders,
} from 'auth/actions/session.actions';

const TEMPORARY_SUFFIX = 'Temporary';
const STATUS_CREATED = 'CREATED';
const CHAIN_SUFFIX = 'CHAIN_';
const CHAIN_HEAD = 'CHAIN_HEAD';
const CHAIN_SUBORDINATE = 'CHAIN_SUBORDINATE';
const SUPER_CHAIN = 'SUPER_CHAIN';
const INDEPENDENT = 'INDEPENDENT';

function initializeSession(deps, model, session = {}, privileges = {}) {
  const nonLoggedRole = window.devMode ? deps.config.mock : deps.config.anonymous;
  const { baseUrl, oAuthClientId, siteId, jurisdictionId, defaultLocale } = deps.config;

  const defaultSession = {
    baseUrl,
    oAuthClientId,
    siteId,
    privileges,
    rest: restApi,
    role: nonLoggedRole,
    locale: defaultLocale,
    jurisdiction: jurisdictionId,
    loggedIn: false,
    passwordReset: false,
    tokens: {},
    retailer: {},
    firstName: '',
    lastName: '',
    contactPhone: '',
    emailAddress: '',
  };

  const newSession = Object.keys(session).length > 0 ? Object.assign(session, { baseUrl }) : defaultSession;
  delete newSession.sidemenu;
  delete newSession.topmenu;
  delete newSession.pageTitle;
  model.session = newSession;

  DepsService.$ngRedux.dispatch(initializeSessionRedux(newSession));

  if (Object.keys(newSession.tokens).length > 0) {
    DepsService.$ngRedux.dispatch(updateAuthHeaders(newSession.tokens));
  }

  DepsService.updateSession(newSession);
  // TODO be remove
  return model;
}

function applySessionData(params) {
  const {
    model,
    user,
    user: { status, contact, userClass: role, retailerGroups },
    config: { defaultLocale, roles, anonymous },
    loginAs,
    impersonatingDisplayName,
  } = params;
  const roleConfig = roles[role] || {};

  const {
    id,
    lotteryRepId,
    siteId,
    forcePasswordChange = false,
    locale = defaultLocale,
    retailers,
    primaryRetailer,
    independentOwnerId,
    lotteryRepresentatives,
  } = user;

  const retailer = primaryRetailer ? _.find(retailers, { retailerId: primaryRetailer.retailerId }) || _.head(retailers) || {} : {};

  const { firstName, lastName, contactPhone, mobilePhone, emailAddress } = contact;

  const session = {
    firstName,
    lastName,
    contactPhone,
    mobilePhone,
    emailAddress,
    role,
    id,
    lotteryRepId,
    independentOwnerId,
    jurisdiction: siteId,
    passwordReset: forcePasswordChange,
    temporaryUser: status.status === STATUS_CREATED,
    status,
    rest: restApi, // roleConfig.rest,
    locale,
    retailer: Object.assign(retailer, {
      isChain: retailer.retailerType ? retailer.retailerType.indexOf(CHAIN_SUFFIX) !== -1 : false,
      isChainHead: retailer.retailerType ? retailer.retailerType === CHAIN_HEAD : false,
      isChainSubordinate: retailer.retailerType ? retailer.retailerType === CHAIN_SUBORDINATE : false,
      isSuperChain: retailer.retailerType ? retailer.retailerType === SUPER_CHAIN : false,
      isIndependent: retailer.retailerType ? retailer.retailerType === INDEPENDENT : false,
    }),
    retailerGroups,
    ownerRetailerGroups: undefined,
    isAdmin: role.indexOf('ADMIN') > -1,
    isRetailerGroup: role.indexOf('RETAILER_GROUP') > -1,
    retailers,
    lotteryRepresentatives,
    loginAs,
    impersonatingDisplayName,
    loggedIn: loginAs ? true : role !== anonymous && !forcePasswordChange,
    multistore: retailers.length > 1 && retailer.retailerType !== SUPER_CHAIN,
    retailerDashboard: void 0,
  };

  if (!loginAs && (status.status === STATUS_CREATED || forcePasswordChange)) {
    session.role += TEMPORARY_SUFFIX;
  }

  session.retailersIds =
    session.retailer.isChainHead || session.retailer.isSuperChain ? retailers.map((r) => r.retailerId).join(',') : retailer.retailerId;

  Object.assign(model, { session: Object.assign(model.session, session) });

  DepsService.$ngRedux.dispatch(applySessionDataRedux(session));
  // update rest in deps service
  DepsService.updateSession(session);

  return Promise.resolve(model);
}

function changeLocale(deps, model, locale) {
  DepsService.$ngRedux.dispatch(changeLocaleRedux(locale));
  return Promise.resolve(model);
}

function saveSession(sessionStorage, model) {
  DepsService.$ngRedux.dispatch(applySessionDataRedux(model.session));
  return Promise.resolve(model);
}

function resetSession(deps, model) {
  DepsService.$ngRedux.dispatch(setAttemptedRoute(''));
  DepsService.$ngRedux.dispatch(resetSessionRedux());
  model = initializeSession(deps, model, {}, deps.anonymousPrivileges);
  return Promise.resolve(model);
}

function setRetailer(retailer) {
  DepsService.model.session.retailer = retailer;
  DepsService.model.session.retailersIds = DepsService.session.retailer.isChainHead
    ? DepsService.model.session.retailers.map((r) => r.retailerId).join(',')
    : retailer.retailerId;
  DepsService.$ngRedux.dispatch(
    applySessionDataRedux({
      retailer,
      retailersIds: DepsService.model.session.retailersIds,
    })
  );
  return Promise.resolve();
}

function updateSession(deps, model, newSession) {
  model.session = Object.assign(model.session, newSession);
  DepsService.$ngRedux.dispatch(applySessionDataRedux(newSession));
}

export default {
  applySessionData,
  saveSession,
  updateSession,
  resetSession,
  initializeSession,
  setRetailer,
  changeLocale,
};



// WEBPACK FOOTER //
// ./src/modules/auth/logic/session.js